export default {
  clientId: process.env.VUE_APP_OIDC_CLIENT_ID,
  issuer: process.env.VUE_APP_OIDC_ISSUER,
  redirectUri: process.env.VUE_APP_OIDC_REDIRECT_URI,
  scopes: process.env.VUE_APP_OIDC_SCOPES.split(','),
  pkce: true,
  isAuthzBackground: false,
  authnUrl: process.env.VUE_APP_OIDC_AUTHN_URL
}